<template>
  <div>
    <h2 class="mb-4">
      <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
      <span v-else>{{ $t("system-flow.new") }}</span>
      <a href="/management/system-flow" class="float-right"> <i class="fa fa-chevron-left"></i> {{ $t("system-flow.library") }}</a>
    </h2>

    <b-row>
      <b-col>
        <label :class="form.active ? 'text-success' : ''">
          <b-form-checkbox v-model="form.active" switch size="lg" class="custom-checkbox-success">
            <i class="fa fa-bolt"></i>
            {{ $t("system-flow.active") }}
          </b-form-checkbox>
        </label>
      </b-col>
    </b-row>
    <!---->

    <b-row class="mt-3">
      <b-col>
        <label
          >{{ $t("system-flow.name") }} <small class="text-muted"> ({{ $t("system-flow.name-info") }})</small></label
        >
        <b-form-input v-model="form.name" :placeholder="$t('system-flow.name')"></b-form-input>
      </b-col>
    </b-row>

    <!---->

    <b-row class="mt-3">
      <b-col>
        <label>{{ $t("system-flow.description") }}</label>
        <textarea v-model="form.description" :placeholder="$t('system-flow.description')" class="form-control"></textarea>
      </b-col>
    </b-row>

    <!---->

    <b-row class="mt-3">
      <b-col>
        <label>
          {{ $t("system-flow.when.text") }}
        </label>

        <select v-model="form.when" class="form-control">
          <option value="ORGANIZATION_CREATED">Organizasyon Oluşturulduğunda</option>
          <option value="DEPARTMENT_CREATED">Birim Oluşturulduğunda</option>
          <option value="PROCESS_CREATED">Faaliyet Oluşturulduğunda</option>
          <option value="DATASOURCE_CREATED">Veri Kaynağı Oluşturulduğunda</option>
          <option value="DATASUBJECT_CREATED">İlgili Kişi Oluşturulduğunda</option>
          <option value="DATASOURCE_UPDATED">Veri Kaynağı Güncellendiğinde</option>
          <option value="THIRDPARTY_CREATED">3.Taraf Eklendiğinde</option>
          <option value="DATASOURCE_PHYSICAL_ARCHIVE_CREATED">Fiziksel Arşiv Ortamı, Veri Kaynağı ile ilişkilendirildiğinde</option>
          <option value="DATASOURCE_PHYSICAL_STORAGE_CREATED">Fiziksel Saklama Ortamı, Veri Kaynağı ile ilişkilendirildiğinde</option>
          <option value="ORGANIZATION_MEMBER_JOINED">Organizasyona Davet Edilen Kişi Organizasyona Erişebilir Olduğunda</option>
          <option value="ORGANIZATION_MEMBER_ROLE_CHANGED">Organizasyon Üyesinin Rolü Değiştiğinde</option>
          <option value="ROADMAP_STAGE_COMPLETED">Roadmap Aşaması Tamamlandığında</option>
          <option value="POLICY_STATUS_CHANGED">Tedbir Statusü Değiştiğinde</option>
          <option value="DATASOURCE_COLLECT_MINIMIZED">Veri Kaynağı, Toplama Minimizasyonuna Uğradığında</option>
          <option value="DATA_COLLECT_MINIMIZED">Veri, Toplama Minimizasyonuna Uğradığında</option>
          <option value="DATASUBJECT_TRANSFER_MINIMIZED">İlgili Kişi, Aktarım Minimizasyonuna Uğradığında</option>
          <option value="DATASOURCE_TRANSFER_MINIMIZED">Veri Kaynağı, Aktarım Minimizasyonuna Uğradığında</option>
        </select>
      </b-col>
    </b-row>
    <!---->

    <b-row class="mt-3">
      <b-col>
        <label>{{ $t("system-flow.products") }}</label>

        <b-form-tags v-model="form.taskFlowAction.products" size="lg" class="mb-2" add-on-change no-outer-focus>
          <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
            <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || products.length === 0" :options="scopedProducts">
              <template #first>
                <!-- This is required to prevent bugs with Safari -->
                <option disabled value=""> {{ $t("product.text") }}</option>
              </template>
            </b-form-select>

            <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
              <li v-for="tag in tags" :key="tag" class="list-inline-item">
                <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="primary">{{ tag }}</b-form-tag>
              </li>
            </ul>
            <b-form-text v-else>
              <span class="text-danger">{{ $t("product.required") }}</span>
            </b-form-text>
          </template>
        </b-form-tags>
      </b-col>
    </b-row>

    <!---->

    <b-row class="mt-3">
      <b-col>
        <label>
          Tekillik Seviyesi
        </label>

        <select v-model="form.uniqueness" class="form-control">
          <option :value="null">Yok</option>
          <option value="organization">Organizasyon</option>
          <option
            v-if="
              [
                'PROCESS_CREATED',
                'DATASOURCE_CREATED',
                'DATASOURCE_UPDATED',
                'DATASOURCE_COLLECT_MINIMIZED',
                'DATA_COLLECT_MINIMIZED',
                'DATASUBJECT_TRANSFER_MINIMIZED',
                'DATASOURCE_PHYSICAL_ARCHIVE_CREATED',
                'DATASOURCE_PHYSICAL_STORAGE_CREATED',
              ].includes(form.when)
            "
            value="department"
            >Birim</option
          >
          <option
            v-if="
              [
                'DATASOURCE_CREATED',
                'DATASOURCE_UPDATED',
                'DATASOURCE_COLLECT_MINIMIZED',
                'DATA_COLLECT_MINIMIZED',
                'DATASUBJECT_TRANSFER_MINIMIZED',
                'DATASOURCE_PHYSICAL_ARCHIVE_CREATED',
                'DATASOURCE_PHYSICAL_STORAGE_CREATED',
              ].includes(form.when)
            "
            value="process"
            >Faaliyet</option
          >

          <option v-if="['DATASUBJECT_CREATED'].includes(form.when)" value="datasubject">Kütüphane Varlığı</option>
          <option v-if="['PROCESS_CREATED'].includes(form.when)" value="process">Kütüphane Varlığı</option>
          <option v-if="['THIRDPARTY_CREATED'].includes(form.when)" value="thirdparty">Kütüphane Varlığı</option>

          <option
            v-if="['DATA_COLLECT_MINIMIZED', 'DATASUBJECT_TRANSFER_MINIMIZED', 'DATASOURCE_PHYSICAL_ARCHIVE_CREATED', 'DATASOURCE_PHYSICAL_STORAGE_CREATED'].includes(form.when)"
            value="datasource"
            >Veri Kaynağı</option
          >
          <option v-if="['DATASUBJECT_TRANSFER_MINIMIZED'].includes(form.when)" value="data">Veri</option>
        </select>
      </b-col>
    </b-row>
    <!---->
    <hr />
    <div class="mt-3">
      <h4 class="mt-4">{{ $t("system-flow.task-definitions") }}</h4>
      <div v-if="form.when">
        <system-flow-task-definition-form store="managementSystemFlow" :when="form.when" class="mt-4" />
      </div>
      <div v-for="task in form.taskFlowAction.taskDefinitions" :key="task._id" class="card card-body">
        <h6>
          {{ $t("task.name") }}
        </h6>

        {{ task.name | translate }}
        <h6 class="mt-2">{{ $t("task.description") }}</h6>
        {{ task.description | translate }}

        <h6 class="mt-2">{{ $t("role.text") }}</h6>
        <div v-if="task.role">
          <span class="badge badge-soft-primary">
            {{ task.role.name | translate }}
          </span>
        </div>
        <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
          <h6>{{ $t("task.blocked-by") }}</h6>
          <ol>
            <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
          </ol>
        </div>

        <b-row>
          <b-col md="1">
            <div @click="removeTaskItem(task)" class=" text-danger hand"><i class="mdi mdi-delete"></i> Görevi Sil</div>
          </b-col>
          <b-col md="2">
            <div @click="editTaskItem(task)" class="text-warning hand"><i class="mdi mdi-pencil"></i> Görevi Güncelle</div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="card card-body">
      <b-form-radio-group v-model="roadmapRelationType" :options="roadmapRelationTypes" name="radios-btn-default" buttons></b-form-radio-group>
      <!---->
      <div v-if="roadmapRelationType" class="card card-body ">
        <div>
          <b-row class="mt-2">
            <b-col>
              <label>
                Roadmap seçiniz
              </label>

              <select v-model="form.taskFlowAction.relatedRoadmapStageTask.roadmapDefinition" class="form-control">
                <option value="PLATFORM_ROADMAP">
                  Platform Roadmap
                </option>
                <option value="GDPR_PRODUCT_ROADMAP">
                  GDPR Roadmap
                </option>
                <option value="KVKK_PRODUCT_ROADMAP">
                  KVKK Roadmap
                </option>
                <option value="BGYS_PRODUCT_ROADMAP">
                  BGYS Roadmap
                </option>
                <option value="DDO_PRODUCT_ROADMAP">
                  DDO Roadmap
                </option>
              </select>
            </b-col>
          </b-row>

          <b-row v-if="form.taskFlowAction.relatedRoadmapStageTask.roadmapDefinition" class="mt-2">
            <b-col>
              <label>
                Roadmap aşaması seçiniz
              </label>
              <select v-model="form.taskFlowAction.relatedRoadmapStageTask.stageDefinition" class="form-control">
                <option v-for="i in stagesForSelectedRoadmap" :value="i" :key="i"> {{ stringifyRoadmapStageDefinition(i) }} </option>
              </select>
            </b-col>
          </b-row>

          <b-row v-if="roadmapRelationType == 'roadmapStageTask' && form.taskFlowAction.relatedRoadmapStageTask.stageDefinition" class="mt-2">
            <b-col>
              <label>
                Roadmap aşamasından bir görev tanımı seçiniz
              </label>

              <filter-select
                id="roadmapTaskDefinitionFilter"
                ref="roadmapTaskDefinitionFilter"
                placeholder="Görev Tanımı"
                :multiple="false"
                @filter="onRoadmapTaskDefinitionSearch"
                :selected="form.taskFlowAction.relatedRoadmapStageTask.taskDefinition"
                @changed="onRoadmapTaskDefinitionSelect"
              />
            </b-col>
          </b-row>
        </div>
      </div>

      <!---->
    </div>

    <hr />

    <query-builder :config="config" v-model="form.rule">
      <template #groupControl="props">
        <GroupControlSlot :props="props" :when="form.when" />
      </template>
    </query-builder>

    <sweet-button @click="save()" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
import QueryBuilder from "query-builder-vue";
import GroupControlSlot from "./component/rule/group-control-slot";
import SystemFlowTaskDefinitionForm from "./component/system-flow-task-definition-form";
import rules from "./rule";

const state = "managementSystemFlow";
export default {
  components: { QueryBuilder, GroupControlSlot, SystemFlowTaskDefinitionForm },
  data() {
    return {
      roadmapRelationTypes: [
        { text: "Roadmap ya da Roadmap Görevleri ile ilişkili Değil", value: null },
        { text: "Roadmap'e ait bir görev ile ilişkili mi?", value: "roadmapStageTask" },
        { text: "Roadmap ile ilişkili mi?", value: "roadmapStage" },
      ],
      roadmapRelationType: null,
      form: {
        taskFlowAction: {
          relatedRoadmapStageTask: {
            stageDefinition: null,
            roadmapDefinition: null,
          },
        },
      },

      roadmapStages: [],
      isThereUnsavedChange: false,
      reloadMessage: this.$t("common.reload-message"),
      config: {
        rules,
        operators: [
          {
            name: "VE",
            identifier: "AND",
          },
          {
            name: "VEYA",
            identifier: "OR",
          },
        ],
        dragging: {
          animation: 300,
          disabled: false,
          dragClass: "sortable-drag",
        },
        colors: ["green", "blue", "orange", "red", "purple"],
      },
    };
  },
  watch: {
    "form.when": {
      handler(v, o) {
        if (v && o && v !== o) this.form.uniqueness = null;
      },
    },

    form: {
      handler(v, old) {
        if (!old?.name) {
          return;
        }
        this.isThereUnsavedChange = true;
      },
    },

    editedEntity: {
      async handler(v) {
        this.$store.commit(`${state}/tasks`, v.taskFlowAction?.taskDefinitions ?? []);

        const value = { ...v };
        if (!("taskFlowAction" in value)) {
          value.taskFlowAction = { relatedRoadmapStageTask: {} };
        } else {
          if (value.taskFlowAction.isRelatedWithRoadmapStageTask) {
            this.roadmapRelationType = "roadmapStageTask";
          } else if (value.taskFlowAction.isRelatedWithRoadmapStage) {
            this.roadmapRelationType = "roadmapStage";
          } else {
            this.roadmapRelationType = null;
          }
        }
        this.form = { ...this.prepareFormForEdit(value) };
      },
    },
    tasks: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form.taskFlowAction = {
          ...this.form.taskFlowAction,
          taskDefinitions: v,
        };
      },
    },

    "form.taskFlowAction.relatedRoadmapStageTask.stageDefinition": {
      handler(v) {
        if (this.$refs.roadmapTaskDefinitionFilter) {
          this.$refs.roadmapTaskDefinitionFilter.reset();
        }
      },
    },
    "form.taskFlowAction.relatedRoadmapStageTask.roadmapDefinition": {
      async handler(v) {
        const roadmapDefinition = this.form.taskFlowAction.relatedRoadmapStageTask.roadmapDefinition;
        let store = "managementPlatformRoadmap";
        if (roadmapDefinition == "GDPR_PRODUCT_ROADMAP") {
          store = "managementGdprRoadmap";
        } else if (roadmapDefinition == "KVKK_PRODUCT_ROADMAP") {
          store = "managementKvkkRoadmap";
        } else if (roadmapDefinition == "BGYS_PRODUCT_ROADMAP") {
          store = "managementBgysRoadmap";
        } else if (roadmapDefinition == "DDO_PRODUCT_ROADMAP") {
          store = "managementDdoRoadmap";
        }

        this.roadmapStages = await this.$store.dispatch(`${store}/loadStages`);
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },

    stagesForSelectedRoadmap() {
      return this.roadmapStages.flatMap((i) => i.definition);
    },

    tasks() {
      return this.$store.getters[`${state}/tasks`];
    },

    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },

  async mounted() {
    this.beforeUnload = this.beforeUnload.bind(this);
    if (this.$route.params.id) {
      this.findById(this.$route.params.id);
    }

    window.addEventListener("beforeunload", this.beforeUnload);
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },

  async beforeRouteLeave(to, from, next) {
    if (!this.isThereUnsavedChange) {
      next();
      return;
    }
    const answer = await this.confirm(this.reloadMessage);
    if (answer) {
      next();
    } else {
      next(false);
    }
  },

  methods: {
    stringifyRoadmapStageDefinition(definition) {
      const key = definition.toLowerCase().replace(/_/g, "-");
      return this.$t(`roadmap.stage.${key}`);
    },
    beforeUnload(e) {
      if (!this.isThereUnsavedChange) {
        return undefined;
      }

      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },
    async findById(id) {
      const response = await this.$store.dispatch(`${state}/findById`, id);

      this.$store.commit(`${state}/editedEntity`, response.data);
    },

    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const form = { ...this.form };

        if (this.roadmapRelationType == "roadmapStageTask") {
          form.taskFlowAction.isRelatedWithRoadmapStageTask = true;
          form.taskFlowAction.isRelatedWithRoadmapStage = false;
        } else if (this.roadmapRelationType == "roadmapStage") {
          form.taskFlowAction.isRelatedWithRoadmapStage = true;
          form.taskFlowAction.isRelatedWithRoadmapStageTask = false;
        } else {
          form.taskFlowAction.isRelatedWithRoadmapStage = false;
          form.taskFlowAction.isRelatedWithRoadmapStageTask = false;
          form.taskFlowAction.relatedRoadmapStageTask = { stageDefinition: null, roadmapDefinition: null };
        }

        await this.$store.dispatch(`${state}/save`, form);
        this.$toast.success(this.$t("common.success"));
        this.isThereUnsavedChange = false;

        window.location = "/management/system-flow";
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    //
    async onRoadmapTaskDefinitionSearch(value, callback) {
      const stageDefinition = this.form.taskFlowAction.relatedRoadmapStageTask.stageDefinition;

      const tasks = this.roadmapStages.filter((r) => r.definition == stageDefinition).flatMap((i) => i.tasks);

      callback(tasks);
    },
    onRoadmapTaskDefinitionSelect(taskDefinition) {
      this.form.taskFlowAction.relatedRoadmapStageTask = {
        ...this.form.taskFlowAction.relatedRoadmapStageTask,
        taskDefinition,
      };

      /*
       this.form = {
        ...this.form,
        taskFlowAction: {
          ...this.form.taskFlowAction,
          relatedRoadmapStageTask: {
            ...this.form.taskFlowAction.relatedRoadmapStageTask,
            taskDefinitionId: item._id,
          },
        },
      };*/
    },

    async removeTaskItem(task) {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      this.$store.commit(`${state}/removeTaskItem`, { task });
    },

    editTaskItem(task) {
      this.$store.commit(`${state}/editedTask`, { ...task });

      this.$root.$emit("bv::toggle::collapse", `sidebar-create-task`);
    },
  },
};
</script>
